import { render, staticRenderFns } from "./DealsContactPerson.vue?vue&type=template&id=5e7c29e2"
import script from "./DealsContactPerson.vue?vue&type=script&lang=js"
export * from "./DealsContactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports